/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import useLocales from '@/hooks/useLocales';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {Modal, Box, DialogActions} from '@mui/material';
import {XMarkIcon} from '@heroicons/react/20/solid';
import {LoadingButton} from '@mui/lab';

type ItemUploadProps = {
  title?: string;
  subtext?: string;
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setIsNew: React.Dispatch<React.SetStateAction<boolean>>;
  confirmButtonText?: string;
};

const style = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 380,
  borderRadius: '8px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  px: 1
};

const EditOptionWarning = ({
  open,
  setOpen,
  setIsNew,
  title,
  subtext,
  confirmButtonText
}: ItemUploadProps) => {
  const {translate} = useLocales();

  const handleClose = () => {
    setOpen(false);
    setIsNew(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <DialogTitle>
            <div
              className={`flex items-center ${title ? 'justify-between' : 'justify-end '}`}
            >
              <div>{title}</div>
              <XMarkIcon
                onClick={() => handleClose()}
                className="h-7 w-7 cursor-pointer text-gray-300"
              />
            </div>
          </DialogTitle>
          <DialogContent>
            <p>{translate(subtext || 'edit_option_text')}</p>
          </DialogContent>
          {confirmButtonText && (
            <DialogActions className="p-[15px]">
              <LoadingButton
                onClick={handleClose}
                className="bg-[#144A6C] capitalize text-white text-[14px] font-medium primary-button"
              >
                {confirmButtonText}
              </LoadingButton>
            </DialogActions>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default EditOptionWarning;
